import { Image } from 'expo-image';
import { router, Stack, useLocalSearchParams } from 'expo-router';
import { Platform, View } from 'react-native';
import { UnistylesRuntime, useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import {
  navigateToDashboardRatings,
  parseDashboardMonthCount,
} from '@/components/dashboard/dashboard-route-params';
import { isDesktop } from '@/core';

const MOBILE_CONTENT_INSET = 16;

function DashboardHeaderLogo() {
  const logoLeadingInset = Platform.OS === 'ios' ? MOBILE_CONTENT_INSET : 8;

  return (
    <View
      style={{
        height: 44,
        justifyContent: 'center',
        paddingLeft: logoLeadingInset,
      }}
    >
      <Image
        style={{ width: 86, height: 32 }}
        source={
          UnistylesRuntime.themeName === 'dark'
            ? require('@/../public/images/logos/partner-logo-dark.png')
            : require('@/../public/images/logos/partner-logo-light.png')
        }
        contentFit="contain"
      />
    </View>
  );
}

function DashboardStackBackButton() {
  return (
    <BackButton
      onPress={() => {
        if (Platform.OS === 'android' && router.canDismiss()) {
          router.dismiss();
        }

        router.navigate('/partner/dashboard');
      }}
    />
  );
}

function CarRatingsStackBackButton() {
  const { months } = useLocalSearchParams<{ months?: string }>();

  return (
    <BackButton
      onPress={() => {
        if (Platform.OS === 'android' && router.canDismiss()) {
          router.dismiss();
        }

        navigateToDashboardRatings(
          router,
          parseDashboardMonthCount(months)
        );
      }}
    />
  );
}

export default function DashboardScreen() {
  const { theme } = useStyles();
  return (
    <Stack>
      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="index"
          options={{
            headerTitle: '',
            headerLeft: () => <DashboardHeaderLogo />,
            headerBackVisible: false,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="metrics"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="metrics"
          options={{
            headerTitle: 'Metrics',
            headerTitleAlign: 'center',
            headerLeft: DashboardStackBackButton,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="car-ratings"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="car-ratings"
          options={{
            headerTitle: 'Car ratings',
            headerTitleAlign: 'center',
            headerLeft: CarRatingsStackBackButton,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}
    </Stack>
  );
}
